import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all rental management maintenance
export const fetchrentalManagementMaintenance = createAsyncThunk(
  "rental_management_maintenance/fetchAll",
  async (page = 1, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/rental-management/maintenance?page=${page}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data; // Return the whole response including pagination
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return rejectWithValue(message);
    }
  }
);


// add rental management maintenance
export const addRentalManagementMaintenance = createAsyncThunk(
  "rental_management_maintenance/add",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/rental-management/maintenance/store`, userData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue(message);
    }
  }
);
// get rental management maintenance record
export const rentalManagementMaintenanceRecord = createAsyncThunk(
  "rental_management_maintenance/rentalManagementMaintenanceRecord",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/rental-management/maintenance/show/${id}`);
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue({ message });
    }
  }
);
// update rental management maintenance
export const updateRentalManagementMaintenance = createAsyncThunk(
  "rental_management_maintenance/updateRentalManagementMaintenance",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/rental-management/maintenance/update`,
        { rental_id: id, ...formData },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
            Lang: i18n.language,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue(message);
    }
  }
);
// delete rental management maintenance
export const deleteRentalManagementMaintenance = createAsyncThunk(
  "rental_management_maintenance/deleteRentalManagementMaintenance",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/rental-management/maintenance/delete`,
        { rental_id: id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to delete rental management maintenance";
      return rejectWithValue({ message });
    }
  }
);
const FleetManagmentMaintenanceSlice = createSlice({
  name: "rental_management_maintenance",
  initialState: {
    rental_management_maintenance: [],
    record: null,
    isLoading: false,
    error: null,
    success: null,
    successDelete: null,
    errorDelete: null,
    pagination: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchrentalManagementMaintenance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchrentalManagementMaintenance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.rental_management_maintenance = action.payload.data.data;
        state.pagination = action.payload.data.pagination;
      })
      .addCase(fetchrentalManagementMaintenance.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load data";
      })
      .addCase(addRentalManagementMaintenance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addRentalManagementMaintenance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addRentalManagementMaintenance.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      })
      .addCase(rentalManagementMaintenanceRecord.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(rentalManagementMaintenanceRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload.data;
      })
      .addCase(rentalManagementMaintenanceRecord.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to add data";
      })
      .addCase(updateRentalManagementMaintenance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateRentalManagementMaintenance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(updateRentalManagementMaintenance.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          "Failed to update record";
      })
      .addCase(deleteRentalManagementMaintenance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteRentalManagementMaintenance.fulfilled, (state, action) => {
        state.isLoading = false;

        // Remove from data array inside rental management maintenance
        if (state.rental_management_maintenance?.data) {
          state.rental_management_maintenance.data = state.rental_management_maintenance.data.filter(
            (record) => record.id !== action.meta.arg
          );
        }

        state.successDelete = action.payload?.message || "Deleted successfully";
      })
      .addCase(deleteRentalManagementMaintenance.rejected, (state, action) => {
        state.isLoading = false;
        state.errorDelete =
          action.payload?.message ||
          action.payload ||
          action.error?.message ||
          "Failed to delete rental management maintenance";
      });
  },
});

export const { clearState } = FleetManagmentMaintenanceSlice.actions;
export default FleetManagmentMaintenanceSlice.reducer;
